import AlarmMsg from '@/utils/alarmMsg';
import router from '@/router';

// 사업자제한 / 환불계좌 체크 (restrictionType : B(사업자제한), R(환불계좌))
export async function rmRestrictionCheck(restrictionType, isMasterMember) {
	// 사업자제한
	if (restrictionType === 'B') {
		await AlarmMsg.showMsg('해당 상품은 법인 사업자 전용 상품입니다.');
		return;
	}
	// 환불계좌 제한
	else {
		if (isMasterMember) {
			if (
				await AlarmMsg.showSafetyConfirm(
					'해당 상품은<br/>정책 외 거래를 제한하기 위해<br/>사업자 인증을 위한 사업자 계좌<br/>등록이 필요합니다.<br/>계좌 등록 후<br/>관리자 승인까지 최대 1일 소요되며,<br/>승인 완료 후 상품 구매가 가능합니다.<br/>계좌를 등록하시겠습니까?',
					'확인',
					'환불계좌 등록',
					'취소'
				)
			) {
				router.push({ name: 'refundaccountmng' });
			}
		} else {
			await AlarmMsg.showMsg(
				'해당 상품은<br/>정책 외 거래를 제한하기 위해<br/>사업자 인증을 위한 사업자 계좌<br/>등록이 필요합니다.<br/>마스터 회원 계정으로 환불계좌<br/>등록 후 다시 이용해주세요.'
			);
			return;
		}
	}
}
/** 0개 : 등급할인만
 *  n개 : 등급+이벤트할인
 * leng : 이벤트만
 */
export function checkDiscountType(target) {
	let result = 0;
	target.forEach(item => {
		// goodsEventDiscountRate는 이벤트 할인율 사용값
		// 값이 있거나, 0일때 이벤트 가격 discountPrice 표기한다.
		if (item.allLevelEventYn === 'Y' || item.goodsEventDiscountRate === 0) result++;
	});
	// console.log('result :', result);
	return result;
}
